module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/$.is-object.js
// module id = 3
// module chunks = 0